/* IvitaPure — Crealyte PDP: omdömen. På mobil sveps korten i sidled; prickarna
   visar vilket kort som syns och går att klicka. Långa omdömen kortas med CSS och
   får en "Läs mer"-knapp bara när texten faktiskt klipps. Idempotent, binds igen
   när temaredigeraren laddar om sektionen. */
(function () {
  function init(root) {
    var list = root.querySelector('[data-cpdp-rv-list]');
    if (!list || list.__cpdpRv) return;
    list.__cpdpRv = true;
    var cards = Array.prototype.slice.call(list.querySelectorAll('[data-cpdp-rv-card]'));
    var dotsWrap = root.querySelector('[data-cpdp-rv-dots]');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('button')) : [];
    var mq = window.matchMedia('(max-width: 899.98px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function isCarousel() { return mq.matches && list.scrollWidth > list.clientWidth + 2; }

    function active() {
      var left = list.getBoundingClientRect().left;
      var best = 0, dist = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - left - parseFloat(getComputedStyle(list).paddingLeft || 0));
        if (d < dist) { dist = d; best = i; }
      });
      /* sista kortet kan inte snäppa till vänsterkanten: räkna det som aktivt vid slutet */
      if (list.scrollLeft + list.clientWidth >= list.scrollWidth - 2) best = cards.length - 1;
      return best;
    }

    function syncDots() {
      if (!dotsWrap) return;
      var on = isCarousel();
      dotsWrap.hidden = !on;
      list.tabIndex = on ? 0 : -1;
      if (!on) return;
      var a = active();
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === a ? 'true' : 'false'); });
    }

    /* Kortets läge räknas mot listan själv (inte offsetLeft, som beror på vilken
       förälder som råkar vara positionerad). */
    function leftOf(c) {
      var pad = parseFloat(getComputedStyle(list).paddingLeft || 0);
      return c.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft - pad;
    }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var c = cards[i];
        if (!c) return;
        list.scrollTo({ left: leftOf(c), behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    var raf = 0;
    list.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; syncDots(); });
    }, { passive: true });

    function syncClamp() {
      cards.forEach(function (c) {
        var body = c.querySelector('.cpdp-rv-body');
        if (!body || c.classList.contains('is-open')) return;
        c.classList.toggle('is-clamped', mq.matches && body.scrollHeight > body.clientHeight + 2);
      });
    }

    cards.forEach(function (c) {
      var btn = c.querySelector('[data-cpdp-rv-more]');
      if (!btn) return;
      var more = btn.textContent;
      var less = btn.getAttribute('data-less') || more;
      btn.addEventListener('click', function () {
        var open = !c.classList.contains('is-open');
        c.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? less : more;
      });
    });

    function syncAll() { syncClamp(); syncDots(); }
    if (mq.addEventListener) { mq.addEventListener('change', syncAll); }
    window.addEventListener('resize', function () { clearTimeout(list.__cpdpRvT); list.__cpdpRvT = setTimeout(syncAll, 150); });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(syncAll); }
    syncAll();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.cpdp-rv').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  if (!window.__cpdpRvLoad) {
    window.__cpdpRvLoad = true;
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }
})();
